// returns the portal container element based on the id,
// creating it along the way if it does not exist yet
export const getPortalContainer = (containerId) => {
  const existing = document.getElementById(containerId);
  if (existing) return existing;

  const container = document.createElement('div');
  container.id = containerId;
  document.body.appendChild(container);
  return container;
};
